export const LANGUAGES = {
  en: {
    common:{
       combinedinput_label:"Email or Phone Number"
    },
    success: {
      signin: {
        label: "You have signed in successfully!",
      },
      signup: {
        label: "Your account has been created successfully!",
      },
    },
    signin: {
      label: "Sign In or Create Account",
      sublabel: "Enter your email or phone number to get started.",
      footer:
        "By continuing you agree to our Terms of service, Privacy policy and Biometric policy",
      show_more_sso: "Show more SSO",
      mobile_input_label: "Mobile Number",
      email_input_label: "Email",
      dont_have_account: "Don’t have an account? ",
      register: "Register",
      continue: "Continue",
      tabs: [
        {
          label: "Mobile Number",
          value: "phone",
        },
        {
          label: "Email",
          value: "email",
        },
      ],
      methods: {
        label: "Signing Method",
        sublabel: "Select the method through which you want sign in.",
        data: [
          {
            label: "Device Biometric",
            value: "biometric",
            icon: "ri-fingerprint-fill",
          },
          {
            label: "Approval from link : Text/Email",
            value: "otp",
            icon: "ri-links-line",
          },
        ],
      },
      approval: {
        email: {
          label: "Waiting for approval",
          sublabel:
            "We have sent an email to ${value} with an approval link. Please open either the link provided in the email or the one in the text message to approve.",
          receive: "Didn't receive the approval email?",
          time_remaining: "You can request another approval email in :",
        },
        phone: {
          label: "Waiting for approval",
          sublabel:
            "We have sent a text message to ${value}. Please open either the link provided in the text message or the one in the email to approve.",
          receive: "Didn't receive the text message?",
          time_remaining: "You can request another text message in :",
        },
        email_phone:{
          label: "Waiting for approval",
          sublabel:
            "An approval link has been sent to your registered contact details. Please open the link to complete the process.",
          receive: "Didn't receive the approval link?",
          time_remaining: "You can request another approval link in :",
        }
      },
    },
    signup: {
      label: "Sign In or Create Account",
      sublabel: "Enter your email or phone number to get started.",
      footer:
        "By continuing you agree to our Terms of service, Privacy policy and Biometric policy",
      show_more_sso: "Show more SSO",
      mobile_input_label: "Mobile Number",
      email_input_label: "Email",
      already_account: "Already have an account? ",
      login: "Log in",
      continue: "Continue",
      verify: {
        phone: {
          image: "phone.svg",
          label: "Verify your phone number",
          description:
            "Kindly click on the link provided in the text message and complete the verification process from there.",
          sublabel: "We have sent you a text message to",
          footer: "Didn’t receive the text message?",
          time_remaining: "You can request another text message in :",
        },
        email: {
          image: "email.svg",
          label: "Verify your email",
          description:
            "Please check your inbox and spam folder. Kindly click on the link provided in the email and complete the verification process from there.",
          sublabel: "A verification email has been sent to ",
          footer: "Didn’t receive the verification email?",
          time_remaining: "You can request another verification email in :",
        },
      },
      verified: {
        phone: {
          label: "Phone number verified successfully",
          sublabel: "You've successfully verified your phone number.",
          image: "success.gif",
        },
        email: {
          label: "Email verified successfully",
          sublabel: "You've successfully verified your email.",
          image: "success.gif",
        },
      },
      "not-verified": {
        phone: {
          label: "Phone number verification failed",
          sublabel:
            "There was an issue verifying your phone number. Please try again.",
          image: "failed.svg",
        },
        email: {
          label: "Email verification failed",
          sublabel:
            "There was an issue verifying your email. Please try again.",
          image: "failed.svg",
        },
      },
      verifying: {
        phone: {
          description: "Verifying your phone number",
          footer:
            "Please do not go back or close this modal until processing is done",
        },
        email: {
          description: "Verifying your email",
          footer:
            "Please do not go back or close this modal until processing is done",
        },
      },
    },
    or: "OR CONTINUE WITH",
  },
  hi: {
    signin: {
      label: "साइन इन करें | खाता बनाएं",
      sublabel: "अपना एसएसओ प्रदाता चुनें या अपना फोन नंबर दर्ज करें।",
      footer:
        "जारी रखने पर आप हमारी सेवा की शर्तों, गोपनीयता नीति और बायोमेट्रिक नीति से सहमत होते हैं",
      show_more_sso: "और एसएसओ दिखाएं",
      mobile_input_label: "मोबाइल नंबर",
      email_input_label: "ईमेल",
      dont_have_account: "क्या आपके पास खाता नहीं है?",
      register: "रजिस्टर करें",
      continue: "जारी रखें",
      tabs: [
        {
          label: "मोबाइल नंबर",
          value: "phone",
        },
        {
          label: "ईमेल",
          value: "email",
        },
      ],

      methods: {
        label: "हस्ताक्षर विधि",
        sublabel: "विधि का चयन करें जिसके माध्यम से आप साइन इन करना चाहते हैं।",
        data: [
          {
            label: "Simplici बायोमेट्रिक",
            value: "biometric",
            icon: "ri-fingerprint-fill",
          },
          {
            label: "लिंक से अनुमोदन: टेक्स्ट/ईमेल",
            value: "otp",
            icon: "ri-links-line",
          },
        ],
      },
      approval: {
        email: {
          label: "अनुमोदन की प्रतीक्षा में",
          sublabel:
            "हमने ${value} पर एक अनुमोदन लिंक के साथ एक ईमेल भेजा है। कृपया अनुमोदन के लिए ईमेल में दिए गए लिंक या टेक्स्ट संदेश में दिए गए लिंक को खोलें।",
          receive: "ईमेल प्राप्त नहीं हुआ?",
          time_remaining: "अगले ओटीपी के लिए शेष समय:",
        },
        phone: {
          label: "अनुमोदन की प्रतीक्षा में",
          sublabel:
            "हमने ${value} पर एक टेक्स्ट संदेश भेजा है। कृपया अनुमोदन के लिए टेक्स्ट संदेश में दिए गए लिंक या ईमेल में दिए गए लिंक को खोलें।",
          receive: "टेक्स्ट संदेश प्राप्त नहीं हुआ?",
          time_remaining: "अगले ओटीपी के लिए शेष समय:",
        },
      },
    },
    signup: {
      label: "साइन इन करें | खाता बनाएं",
      sublabel: "अपना एसएसओ प्रदाता चुनें या अपना फोन नंबर दर्ज करें।",
      footer:
        "जारी रखने पर आप हमारी सेवा की शर्तों, गोपनीयता नीति और बायोमेट्रिक नीति से सहमत होते हैं",
      show_more_sso: "और एसएसओ दिखाएं",
      mobile_input_label: "मोबाइल नंबर",
      email_input_label: "ईमेल",
      already_account: "क्या आपके पास पहले से खाता है?",
      login: "लॉग इन करें",
      continue: "जारी रखें",
      verify: {
        phone: {
          image: "phone.svg",
          label: "अपने मोबाइल नंबर को सत्यापित करें",
          description:
            "कृपया टेक्स्ट संदेश में दिए गए लिंक पर क्लिक करें और सत्यापन प्रक्रिया को पूरा करें।",
          sublabel: "हमने आपको एक टेक्स्ट संदेश भेजा है",
          footer: "टेक्स्ट संदेश प्राप्त नहीं हुआ?",
        },
        email: {
          image: "email.svg",
          label: "अपना ईमेल सत्यापित करें",
          description:
            "कृपया अपने इनबॉक्स और स्पैम फोल्डर को चेक करें। ईमेल में दिए गए लिंक पर क्लिक करें और सत्यापन प्रक्रिया को पूरा करें।",
          sublabel: "सत्यापन ईमेल भेजी गई है",
          footer: "टेक्स्ट संदेश प्राप्त नहीं हुआ?",
        },
      },
      verified: {
        phone: {
          label: "मोबाइल नंबर सफलतापूर्वक सत्यापित हुआ",
          sublabel: "आपने सफलतापूर्वक अपना मोबाइल नंबर सत्यापित किया है।",
          image: "success.gif",
        },
        email: {
          label: "ईमेल सफलतापूर्वक सत्यापित हुआ",
          sublabel: "आपने सफलतापूर्वक अपना ईमेल सत्यापित किया है।",
          image: "success.gif",
        },
      },
      "not-verified": {
        phone: {
          label: "फ़ोन नंबर सत्यापन विफल",
          sublabel:
            "आपके फ़ोन नंबर को सत्यापित करने में समस्या आई। कृपया पुनः प्रयास करें।",
          image: "failed.svg",
        },
        email: {
          label: "ईमेल सत्यापन विफल",
          sublabel:
            "आपके ईमेल को सत्यापित करने में समस्या आई। कृपया पुनः प्रयास करें।",
          image: "failed.svg",
        },
      },
      verifying: {
        phone: {
          description: "आपके मोबाइल नंबर को सत्यापित किया जा रहा है",
          footer:
            "कृपया प्रक्रिया पूरी होने तक वापस न जाएं या इस विंडो को बंद न करें",
        },
        email: {
          description: "आपके ईमेल को सत्यापित किया जा रहा है",
          footer:
            "कृपया प्रक्रिया पूरी होने तक वापस न जाएं या इस विंडो को बंद न करें",
        },
      },
    },
    or: "या",
  },
  ur: {
    signin: {
      label: "سائن ان کریں | اکاؤنٹ بنائیں",
      sublabel:
        "اپنے ایس ایس او فراہم کنندہ کا انتخاب کریں یا اپنا فون نمبر درج کریں۔",
      footer:
        "جاری رکھتے ہوئے آپ ہماری سروس کی شرائط، پرائیویسی پالیسی اور بائیو میٹرک پالیسی سے اتفاق کرتے ہیں",
      show_more_sso: "مزید ایس ایس او دکھائیں",
      mobile_input_label: "موبائل نمبر",
      email_input_label: "ای میل",
      dont_have_account: "کیا آپ کا اکاؤنٹ نہیں ہے؟",
      register: "رجسٹر کریں",
      continue: "جاری رکھیں",
      tabs: [
        {
          label: "موبائل نمبر",
          value: "phone",
        },
        {
          label: "ای میل",
          value: "email",
        },
      ],

      methods: {
        label: "دستخط کرنے کا طریقہ",
        sublabel: "وہ طریقہ منتخب کریں جس کے ذریعے آپ سائن ان کرنا چاہتے ہیں۔",
        data: [
          {
            label: "Simplici بایومیٹرک",
            value: "biometric",
            icon: "ri-fingerprint-fill",
          },
          {
            label: "لنک سے منظوری: ٹیکسٹ/ای میل",
            value: "otp",
            icon: "ri-links-line",
          },
        ],
      },

      approval: {
        email: {
          label: "منظوری کا انتظار",
          sublabel:
            "ہم نے ${value} پر ایک منظوری لنک کے ساتھ ایک ای میل بھیجا ہے۔ براہ کرم منظوری کے لیے ای میل میں دیے گئے لنک یا ٹیکسٹ میسج میں دیے گئے لنک کو کھولیں۔",
          receive: "ای میل موصول نہیں ہوئی؟",
          time_remaining: "اگلے او ٹی پی کے لیے باقی وقت:",
        },
        phone: {
          label: "منظوری کا انتظار",
          sublabel:
            "ہم نے ${value} پر ایک ٹیکسٹ میسج بھیجا ہے۔ براہ کرم منظوری کے لیے ٹیکسٹ میسج میں دیے گئے لنک یا ای میل میں دیے گئے لنک کو کھولیں۔",
          receive: "ٹیکسٹ میسج موصول نہیں ہوا؟",
          time_remaining: "اگلے او ٹی پی کے لیے باقی وقت:",
        },
      },
    },
    signup: {
      label: "سائن ان کریں | اکاؤنٹ بنائیں",
      sublabel:
        "اپنے ایس ایس او فراہم کنندہ کا انتخاب کریں یا اپنا فون نمبر درج کریں۔",
      footer:
        "جاری رکھتے ہوئے آپ ہماری سروس کی شرائط، پرائیویسی پالیسی اور بائیو میٹرک پالیسی سے اتفاق کرتے ہیں",
      show_more_sso: "مزید ایس ایس او دکھائیں",
      mobile_input_label: "موبائل نمبر",
      email_input_label: "ای میل",
      already_account: "کیا آپ کا پہلے سے اکاؤنٹ ہے؟",
      login: "لاگ ان کریں",
      continue: "جاری رکھیں",
      verify: {
        phone: {
          image: "phone.svg",
          label: "اپنے موبائل نمبر کی تصدیق کریں",
          description:
            "براہ کرم ٹیکسٹ پیغام میں فراہم کردہ لنک پر کلک کریں اور تصدیقی عمل کو مکمل کریں۔",
          sublabel: "ہم نے آپ کو ایک ٹیکسٹ پیغام بھیجا ہے",
          footer: "ٹیکسٹ پیغام موصول نہیں ہوا؟",
        },
        email: {
          image: "email.svg",
          label: "اپنا ای میل تصدیق کریں",
          description:
            "براہ کرم اپنے ان باکس اور سپیم فولڈر کو چیک کریں۔ ای میل میں فراہم کردہ لنک پر کلک کریں اور تصدیقی عمل کو مکمل کریں۔",
          sublabel: "تصدیقی ای میل بھیجی گئی ہے",
          footer: "ٹیکسٹ پیغام موصول نہیں ہوا؟",
        },
      },
      verified: {
        phone: {
          label: "موبائل نمبر کامیابی کے ساتھ تصدیق ہوا",
          sublabel: "آپ نے کامیابی سے اپنا موبائل نمبر تصدیق کیا ہے۔",
          image: "success.gif",
        },
        email: {
          label: "ای میل کامیابی کے ساتھ تصدیق ہوا",
          sublabel: "آپ نے کامیابی سے اپنا ای میل تصدیق کیا ہے۔",
          image: "success.gif",
        },
      },
      "not-verified": {
        phone: {
          label: "电话号码验证失败",
          sublabel: "验证您的电话号码时出现问题。请再试一次。",
          image: "failed.svg",
        },
        email: {
          label: "电子邮件验证失败",
          sublabel: "验证您的电子邮件时出现问题。请再试一次。",
          image: "failed.svg",
        },
      },
      verifying: {
        phone: {
          description: "آپ کے موبائل نمبر کی تصدیق کی جا رہی ہے",
          footer:
            "براہ کرم اس وقت تک واپس نہ جائیں یا اس ونڈو کو بند نہ کریں جب تک عمل مکمل نہ ہو جائے",
        },
        email: {
          description: "آپ کے ای میل کی تصدیق کی جا رہی ہے",
          footer:
            "براہ کرم اس وقت تک واپس نہ جائیں یا اس ونڈو کو بند نہ کریں جب تک عمل مکمل نہ ہو جائے",
        },
      },
    },
    or: "یا",
  },
  ch: {
    signin: {
      label: "登录 | 创建账户",
      sublabel: "选择您的单点登录提供商或输入您的手机号。",
      footer: "继续即表示您同意我们的服务条款、隐私政策和生物识别政策",
      show_more_sso: "显示更多单点登录",
      mobile_input_label: "手机号",
      email_input_label: "电子邮件",
      dont_have_account: "没有账户？",
      register: "注册",
      continue: "继续",
      tabs: [
        {
          label: "手机号",
          value: "phone",
        },
        {
          label: "电子邮件",
          value: "email",
        },
      ],

      methods: {
        label: "签名方法",
        sublabel: "选择您要通过其登录的方法。",
        data: [
          {
            label: "Simplici生物识别",
            value: "biometric",
            icon: "ri-fingerprint-fill",
          },
          {
            label: "链接批准：文本/电子邮件",
            value: "otp",
            icon: "ri-links-line",
          },
        ],
      },

      approval: {
        email: {
          label: "等待批准",
          sublabel:
            "我们已向 ${value} 发送了一封带有批准链接的电子邮件。请打开电子邮件中的链接或短信中的链接以进行批准。",
          receive: "未收到电子邮件？",
          time_remaining: "下一个 OTP 剩余时间：",
        },
        phone: {
          label: "等待批准",
          sublabel:
            "我们已向 ${value} 发送了一条短信。请打开短信中的链接或电子邮件中的链接以进行批准。",
          receive: "未收到短信？",
          time_remaining: "下一个 OTP 剩余时间：",
        },
      },
    },
    signup: {
      label: "登录 | 创建账户",
      sublabel: "选择您的单点登录提供商或输入您的手机号。",
      footer: "继续即表示您同意我们的服务条款、隐私政策和生物识别政策",
      show_more_sso: "显示更多单点登录",
      mobile_input_label: "手机号",
      email_input_label: "电子邮件",
      already_account: "已有账户？",
      login: "登录",
      continue: "继续",
      verify: {
        phone: {
          image: "phone.svg",
          label: "验证您的手机号",
          description: "请点击短信中的链接并完成验证过程。",
          sublabel: "我们已向您发送短信",
          footer: "没有收到短信？",
        },
        email: {
          image: "email.svg",
          label: "验证您的电子邮件",
          description:
            "请检查您的收件箱和垃圾邮件文件夹。点击电子邮件中的链接并完成验证过程。",
          sublabel: "验证邮件已发送至",
          footer: "没有收到短信？",
        },
      },
      verified: {
        phone: {
          label: "手机号验证成功",
          sublabel: "您已成功验证手机号。",
          image: "success.gif",
        },
        email: {
          label: "电子邮件验证成功",
          sublabel: "您已成功验证电子邮件。",
          image: "success.gif",
        },
      },
      "not-verified": {
        phone: {
          label: "电话号码验证失败",
          sublabel: "验证您的电话号码时出现问题。请再试一次。",
          image: "failed.svg",
        },
        email: {
          label: "电子邮件验证失败",
          sublabel: "验证您的电子邮件时出现问题。请再试一次。",
          image: "failed.svg",
        },
      },
      verifying: {
        phone: {
          description: "正在验证您的手机号",
          footer: "请不要返回或关闭此窗口，直到处理完成",
        },
        email: {
          description: "正在验证您的电子邮件",
          footer: "在处理完成之前，请不要返回或关闭此窗口",
        },
      },
    },
    or: "或",
  },
};
